'use strict';
(() => {
  const el = document.getElementById('eraze-store-data');
  if (!el) return;
  const store = JSON.parse(el.textContent), words = store.words;
  const root = store.root, cartDialog = document.querySelector('#cart');
  const status = document.querySelector('#cart-status');
  const money = (cents, currency = store.currency) => new Intl.NumberFormat(store.language, {style:'currency',currency}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const quantity = value => Math.max(1,Math.min(10,Math.floor(Number(value) || 1)));
  let cart = null, busy = false;
  function open(dialog) { if (dialog && !dialog.open) dialog.showModal(); document.documentElement.classList.add('modal-open'); }
  function close(dialog) { dialog.close(); if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('modal-open'); }
  async function api(path, body) {
    const response = await fetch(root + path, {credentials:'same-origin',headers:{'Accept':'application/json',...(body ? {'Content-Type':'application/json'}:{})},...(body ? {method:'POST',body:JSON.stringify(body)}:{})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || words.error);
    return data;
  }
  function announce(message, error = false) {
    status.textContent = message;
    let notice = document.getElementById('cart-error');
    if (!notice) { notice = document.createElement('p');notice.id='cart-error';notice.className='cart-error';notice.setAttribute('role','alert');cartDialog?.append(notice); }
    notice.textContent = error ? message : '';
  }
  function renderCart(data) {
    cart = data;
    document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = data.item_count);
    const list = document.querySelector('#cart-items');
    if (!list) return;
    document.querySelector('.cart-bottom').hidden = !data.item_count;
    list.innerHTML = data.items.length ? data.items.map(item => `<article class="cart-item"><a href="${escape(item.url)}">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="120" height="120" loading="lazy">`:''}</a><div><a class="cart-item-name" href="${escape(item.url)}">${escape(item.product_title)}</a>${item.variant_title && item.variant_title !== "Default Title" ? `<p>${escape(item.variant_title)}</p>` : ""}<div class="cart-item-controls"><div class="quantity"><button type="button" data-cart-key="${escape(item.key)}" data-cart-delta="-1" aria-label="${escape(words.minus)}">−</button><span aria-label="${escape(words.quantity)}">${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-delta="1" aria-label="${escape(words.plus)}">+</button></div><button type="button" class="remove" data-remove="${escape(item.key)}">${escape(words.remove)}</button></div></div><strong>${escape(money(item.final_line_price,data.currency))}</strong></article>`).join('') : `<div class="empty-bag"><p>${escape(words.empty)}</p></div>`;
    document.querySelector('#cart-total').textContent = money(data.total_price,data.currency);
    document.dispatchEvent(new CustomEvent('eraze:cart-rendered',{detail:data}));
  }
  async function refresh() { renderCart(await api('cart.js')); }
  document.addEventListener('eraze:offer-cart',event=>renderCart(event.detail));
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close',() => {if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('modal-open');});
    dialog.addEventListener('click',event => {if(event.target !== dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close(dialog);});
  });
  document.querySelectorAll('[data-close-dialog]').forEach(b => b.addEventListener('click',() => close(b.closest('dialog'))));
  document.querySelectorAll('[data-open-cart]').forEach(b => b.addEventListener('click',async () => {open(cartDialog);try{await refresh();}catch(error){announce(error.message,true);}}));
  document.querySelectorAll('[data-product-form]').forEach(form => form.addEventListener('submit',async event => {
    event.preventDefault(); if(busy)return;
    const product=store.products[form.dataset.productForm], button=form.querySelector('[data-add]');
    if(!product?.available)return;
    busy=true;button.disabled=true;button.setAttribute('aria-busy','true');
    try {
      // Order-level evaluation can read this private line property. It records the
      // page used to add the item, without collecting visitor IDs or starting pixels.
      const properties={_eraze_experience:document.body.dataset.erazeExperience || 'store'};
      await api('cart/add.js',{items:[{id:product.id,quantity:quantity(form.querySelector('[name=quantity]')?.value),properties}]});
      await refresh();announce(words.added);open(cartDialog);
    }
    catch(error) {open(cartDialog);announce(error.message,true);}
    finally {busy=false;button.disabled=false;button.removeAttribute('aria-busy');}
  }));
  document.querySelectorAll('[data-quantity]').forEach(b => b.addEventListener('click',() => {const input=b.parentElement.querySelector('input');input.value=quantity(Number(input.value)+Number(b.dataset.quantity));}));
  document.querySelectorAll('.quantity input').forEach(input => input.addEventListener('change',() => input.value=quantity(input.value)));
  document.querySelector('#cart-items')?.addEventListener('click',async event => {
    const remove=event.target.closest('[data-remove]'), delta=event.target.closest('[data-cart-delta]');
    if(busy||(!remove&&!delta)||!cart)return;
    const key=remove?.dataset.remove || delta.dataset.cartKey, item=cart.items.find(i=>i.key===key);
    if(!item)return;
    busy=true;
    try {renderCart(await api('cart/change.js',{id:key,quantity:remove ? 0 : Math.max(0,item.quantity+Number(delta.dataset.cartDelta))}));announce('');}
    catch(error){announce(error.message,true);}
    finally{busy=false;}
  });
  document.querySelectorAll('[data-time]').forEach(button => button.addEventListener('click',() => {
    document.querySelectorAll('[data-time]').forEach(b=>{const active=b.dataset.time===button.dataset.time;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active));});
    document.querySelectorAll('[data-routine]').forEach(panel=>panel.hidden=panel.dataset.routine!==button.dataset.time);
  }));
  document.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click',() => {
    document.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;
    document.querySelectorAll('.collection-grid [data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;if(!card.hidden)count++;});
    const countEl=document.querySelector('#product-count');if(countEl)countEl.textContent=count;
  }));
  document.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click',() => {
    const gallery=button.closest('.gallery'),image=gallery.querySelector('.main-product-image');image.src=button.dataset.image;image.alt=button.querySelector('img').alt;
    gallery.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  document.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click',() => {
    const source=button.querySelector('img'),target=document.querySelector('#zoom img');target.src=source.src;target.alt=source.alt;open(document.querySelector('#zoom'));
  }));
  const localization=document.getElementById('ErazelabLocalization');
  document.querySelectorAll('[data-product-form]').forEach(form=>{
    if(form.querySelector('[name="properties[_eraze_experience]"]'))return;
    const property=document.createElement('input');property.type='hidden';property.name='properties[_eraze_experience]';property.value=document.body.dataset.erazeExperience || 'store';form.append(property);
  });
  function returnTo() {
    if(!localization)return;
    let input=localization.querySelector('[name=return_to]');
    if(!input){input=document.createElement('input');input.type='hidden';input.name='return_to';localization.append(input);}
    input.value=location.pathname+location.search;
  }
  localization?.addEventListener('submit',() => {
    returnTo();try{localStorage.setItem('erazelab-locale-choice',JSON.stringify({language:localization.elements.language_code.value,country:localization.elements.country_code.value}));}catch{}
  });
  async function localizeFirstVisit() {
    if(!localization||store.designMode||/bot|crawler|spider|preview|facebookexternalhit|slurp/i.test(navigator.userAgent))return;
    const params=new URLSearchParams(location.search);
    if(params.has('preview_theme_id')||params.has('locale')||params.has('country')||location.pathname.startsWith('/challenge'))return;
    try {if(localStorage.getItem('erazelab-locale-choice')||sessionStorage.getItem('erazelab-geo-checked'))return;sessionStorage.setItem('erazelab-geo-checked','1');}catch{}
    try {
      const response=await fetch(root+'browsing_context_suggestions.json?country[enabled]=true&country[exclude]='+encodeURIComponent(store.country)+'&language[enabled]=true&language[exclude]='+encodeURIComponent(store.language),{credentials:'same-origin',signal:typeof AbortSignal.timeout==='function'?AbortSignal.timeout(4500):undefined});
      if(!response.ok)return;
      const result=await response.json(),parts=result.suggestions?.[0]?.parts || {};
      const detected=result.detected_values?.country?.handle || parts.country?.handle || store.country;
      const country=store.countries.includes(detected)?detected:store.country;
      if(root!=='/'&&country!=='NL')return;
      const browser=(parts.language?.handle || navigator.languages?.[0] || navigator.language || 'en').split('-')[0].toLowerCase();
      const requested=country==='IT'?'it':country==='FR'?'fr':country==='NL'?'nl':country==='GB'?'en':browser;
      const language=store.languages.includes(requested)?requested:store.languages.includes('en')?'en':store.language;
      if(country===store.country&&language===store.language)return;
      localization.elements.country_code.value=country;
      localization.elements.language_code.value=language;
      returnTo();localization.submit();
    }catch{/* Keep the fully rendered page and manual selector available. */}
  }
  refresh().catch(()=>{});
  localizeFirstVisit();
  function dismissUnfinishedSignup() {
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]').forEach(form => {
      const text = form.textContent || '';
      if (text.includes('jj') && text.includes('Get Your Exclusive Discount & Free Cheat Sheet')) {
        form.querySelector('button[aria-label="Close dialog"]')?.click();
      }
    });
  }
  const signupObserver = new MutationObserver(dismissUnfinishedSignup);
  signupObserver.observe(document.body, {childList:true, subtree:true});
  dismissUnfinishedSignup();
  document.querySelectorAll('[data-creator-video]').forEach(video => {
    video.addEventListener('play', () => {
      document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
    });
  });
  const offerSticky = document.querySelector('.offer-sticky');
  const purchaseForms = [...document.querySelectorAll('.offer-quick-buy, .offer-purchase [data-product-form]')];
  if (offerSticky && purchaseForms.length && 'IntersectionObserver' in window) {
    const visibleForms = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visibleForms.add(entry.target) : visibleForms.delete(entry.target));
      offerSticky.hidden = visibleForms.size > 0;
    }, {threshold: 0.5});
    purchaseForms.forEach(form => observer.observe(form));
  }
})();
document.addEventListener('click', event => {
  const link = event.target.closest('[data-open-inci]');
  if (link) {
    const panel = document.getElementById('full-ingredients');
    if (panel) panel.open = true;
  }
});
function openLinkedIngredients() {
  if (location.hash === '#full-ingredients') {
    const panel = document.getElementById('full-ingredients');
    if (panel) panel.open = true;
  }
}
window.addEventListener('hashchange', openLinkedIngredients);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openLinkedIngredients);
else openLinkedIngredients();


